import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import style from './style.scss'; //NOSONAR

const SelectPage = ({ buttons, totalPages, currentPage, clickButton}) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        document.addEventListener('click', documentClick);

        return function cleanup() {
            document.removeEventListener('click', documentClick);
        }
    });

    const openDropdown = () => {
        setOpen(prevState => !prevState);
    }

    const documentClick = (e) => {
        const firstClass = e.target.classList[0];

        if((firstClass != 'select-page-title') && (firstClass != 'font-icn')) {
            setOpen(false);
        }
    }
    
    return (
        <div className="select-page-content">
            <button className={"select-page-button " + ( open ? ' open ' : '')} onClick={openDropdown}>
                <span className="select-page-title">Página {currentPage} de {totalPages}</span>
                <i className={"font-icn arrow-down" + ( open ? ' open ' : '   ')}></i>
            </button>

            <ul className={"select-page-dropdown-content " + (open ? ' open ' : '')}>
                {buttons.map((item, i) => {
                    return <li key={i} className="select-page-dropdown-item" onClick={() => clickButton(item)}>Página {item}</li>
                })}
            </ul>
        </div>
    )
}

SelectPage.propTypes = {
    buttons: PropTypes.array,
    totalPages: PropTypes.number,
    currentPage: PropTypes.number,
    clickButton: PropTypes.func
}

export default SelectPage;